// import Vue from 'vue';
// import Router from 'vue-router';
// import Home from './views/Home.vue';
//
// Vue.use(Router);
//
// export default new Router({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes: [
//     {
//       path: '/',
//       name: 'home',
//       component: Home,
//     },
//     {
//       path: '/about',
//       name: 'about',
//       // route level code-splitting
//       // this generates a separate chunk (about.[hash].js) for this route
//       // which is lazy-loaded when the route is visited.
//       component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
//     },
//   ],
// });

import Vue from 'vue'

import VueRouter, { Route } from 'vue-router'

import Login from '@/authentication/components/login.vue'
import Logout from '@/authentication/components/logout.vue'
import Organisations from '@/business/organisation/pages/organisations.vue'
import Organisation from '@/business/organisation/pages/organisation.vue'
import OrganisationAbout from '@/business/organisation/components/organisation-about.vue'
import OrganisationOffers from '@/business/organisation/components/organisation-offers.vue'
import OrganisationSettings from '@/business/organisation/components/organisation-settings.vue'
import OrganisationSettingsProfile from '@/business/organisation/components/organisation-settings-profile.vue'
import OrganisationSettingsSecurity from '@/business/organisation/components/organisation-settings-security.vue'
import Offers from '@/business/offers/pages/offers.vue'
import Offer from '@/business/offers/pages/offer.vue'
import Main from '@/main/main.vue'
import RegistrationComponent from '@/authentication/components/registration.vue'
import OrganisationStatistics from '@/business/organisation/components/organisation-statistics.vue'
import Administration from '@/business/administration/pages/administration.vue'
import LandingPage from '@/main/landing-page.vue'
import OfferSettings from '@/business/offers/pages/offer-settings.vue'
import Respondeco404 from '@/shared/components/respondeco-404.vue'
import Inbox from '@/business/message/pages/inbox.vue'
import Team from '@/business/home/pages/team.vue'
import MissionVision from '@/business/home/pages/mission-vision.vue'
import ConfirmAccount from '@/business/account/pages/confirm-account.vue'
import ProjectsPage from '@/business/project/pages/projects-page.vue'
import ProjectPage from '@/business/project/pages/project-page.vue'
import ResourcesPage from '@/business/resource/page/resources-page.vue'
import ResourcePage from '@/business/resource/page/resource-page.vue'
import { RouteConfig } from '@/shared/interfaces/route-config'
import OrganisationProjects from '@/business/organisation/components/organisation-projects.vue'
import ProjectSettingsPage from '@/business/project/pages/project-settings.vue'
import { RouteMetaBuilder } from '@/commons/route-meta-builder'
import Impact from '@/business/home/pages/impact.vue'
import Impressum from '@/main/impressum.vue'
import ConfirmPasswordChange from '@/business/account/pages/confirm-password-change.vue'
import OrganisationActivities from '@/business/organisation/components/organisation-activities.vue'
import OrganisationInteractions from '@/business/organisation/components/organisation-interactions.vue'
import UpdatesPage from '@/business/home/pages/updates-page.vue'
import RecoverPassword from '@/business/account/pages/recover-password.vue'
import Konstanz from '@/business/home/pages/konstanz.vue'
import { environmentConfiguration } from '@/config/environments'
import OfferReportSettingsPage from '@/business/project/pages/offer-report-settings.vue'
import OfferReport from '@/business/project/pages/offer-report.vue'

Vue.use(VueRouter)

export const routes: RouteConfig[] = [
  {
    path: '/',
    component: Main,
    children: [
      {
        component: environmentConfiguration().home,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'home',
        path: '',
      },
      {
        component: Administration,
        meta: RouteMetaBuilder.scrollToTop()
          .admin()
          .build(),

        name: 'administration',
        path: 'administration/:activeStep?',
      },
      {
        name: 'about-us',
        path: 'about',
        meta: {
          redirectTo: {
            name: 'about-team',
          },
        },
      },
      {
        component: Impressum,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'impressum',
        path: 'impressum',
      },
      {
        component: Team,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'about-team',
        path: 'about/team',
      },
      {
        component: MissionVision,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'about-mission-vision',
        path: 'about/mission-vision',
      },
      {
        component: ConfirmAccount,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'confirm-account',
        path: 'account/confirm',
      },
      {
        component: ConfirmPasswordChange,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'confirm-password-change',
        path: 'account/confirm-password-change',
      },
      {
        component: Impact,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'about-impact',
        path: 'about/impact',
      },
      {
        component: Inbox,
        meta: RouteMetaBuilder.scrollToTop()
          .user()
          .build(),

        name: 'inbox',
        path: 'inbox/:organisation?',
      },
      {
        component: LandingPage,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'landing-page',
        path: 'landing-page',
      },
      {
        component: Login,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'login',
        path: '/login',
        props: (route: Route) => {
          return {
            username: route.query.username,
          }
        },
      },
      {
        component: Logout,
        meta: RouteMetaBuilder.scrollToTop()
          .user()
          .build(),

        name: 'logout',
        path: '/logout',
      },
      {
        component: Organisations,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'organisations',
        path: 'organisations',
      },
      {
        component: Organisation,
        meta: RouteMetaBuilder.scrollToTop().build(),
        path: 'organisations/:id',
        props: true,
        name: 'organisation',
        redirect: {
          name: 'organisation-about',
        },
        children: [
          {
            component: OrganisationAbout,
            name: 'organisation-about',
            path: '',
          },
          {
            component: OrganisationActivities,
            name: 'organisation-activities',
            path: 'activities',
          },
          {
            component: OrganisationInteractions,
            name: 'organisation-interactions',
            path: 'interactions',
          },
          {
            component: OrganisationOffers,
            name: 'organisation-offers',
            path: 'offers',
          },
          {
            component: OrganisationProjects,
            name: 'organisation-projects',
            path: 'projects',
          },
          {
            component: OrganisationStatistics,
            name: 'organisation-statistics',
            path: 'statistics',
          },
          {
            alias: 'organisation-settings-profile',
            component: OrganisationSettings,
            path: 'settings',
            children: [
              {
                path: '',
                meta: RouteMetaBuilder.user().build(),
                name: 'organisation-settings-profile',
                component: OrganisationSettingsProfile,
              },
              {
                path: 'security',
                meta: RouteMetaBuilder.user().build(),
                name: 'organisation-settings-security',
                component: OrganisationSettingsSecurity,
              },
            ],
          },
        ],
      },
      {
        component: Offers,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'offers',
        path: 'offers',
      },
      {
        component: Offer,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'offer',
        path: 'offers/:id',
        props: true,
      },
      {
        component: OfferSettings,
        meta: RouteMetaBuilder.scrollToTop()
          .user()
          .build(),

        name: 'offer-settings',
        path: 'offers/:id/edit/:activeStep?',
        props: true,
      },
      {
        component: OfferSettings,
        meta: RouteMetaBuilder.scrollToTop()
          .user()
          .build(),

        name: 'offer-new',
        path: 'offers/:id/edit',
        props: true,
      },
      {
        component: OfferReportSettingsPage,
        meta: RouteMetaBuilder.scrollToTop()
          .user()
          .build(),
        name: 'offer-report-settings',
        path: 'offers/:offerId/report/settings',
        props: route => ({
          offerId: Number(route.params.offerId),
        }),
      },
      {
        component: OfferReport,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'offer-report',
        path: 'offers/:offerId/report',
        props: route => ({
          offerId: Number(route.params.offerId),
        }),
      },
      {
        component: RecoverPassword,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'password-recovery',
        path: 'password-recovery',
        props: (route: Route) => {
          return {
            token: route.query.token,
            username: route.query.username,
          }
        },
      },
      {
        component: ProjectsPage,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'projects',
        path: 'projects',
      },
      {
        component: ProjectPage,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'project',
        path: 'projects/:id',
        props: (route: Route) => ({
          id: Number(route.params.id),
        }),
      },
      {
        component: ProjectSettingsPage,
        meta: RouteMetaBuilder.scrollToTop()
          .admin()
          .build(),

        name: 'project-settings',
        path: 'projects/:id/edit',
        props: route => ({ id: Number(route.params.id) || -1 }),
      },
      {
        component: RegistrationComponent,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'register',
        path: 'register',
      },
      {
        component: ResourcesPage,
        meta: RouteMetaBuilder.scrollToTop()
          .user()
          .build(),

        name: 'resources',
        path: 'resources',
      },
      {
        name: 'resource',
        path: 'resources/:id',
        component: ResourcePage,
        meta: RouteMetaBuilder.scrollToTop()
          .user()
          .build(),

        props: route => ({
          id: Number(route.params.id),
        }),
      },
      {
        name: 'updates',
        path: 'updates',
        component: UpdatesPage,
        meta: RouteMetaBuilder.scrollToTop().build(),
      },
      {
        component: Konstanz,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'konstanz',
        path: 'l/17-ziele-fuer-konstanz',
      },
      {
        component: RegistrationComponent,
        meta: RouteMetaBuilder.scrollToTop().build(),
        name: 'konstanz-registration',
        path: 'l/17-ziele-fuer-konstanz/als-veranstalter-registrieren',
        props: {
          project: 'konstanz',
        },
      },
    ],
  },
  {
    component: Respondeco404,
    path: '*',
  },
]
